import { useDataSourceColumns } from "@/hooks";
import type { CalculateTransformer } from "@/types/workspace";
import { Divider, Input, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerCalculate({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: CalculateTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: CalculateTransformer) => void;
  index: number;
}) {
  const [column, setColumn] = useState(data.item_list[0]?.column || "");
  const [calc, setCalc] = useState(data.item_list[0]?.calc || "");
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    setColumn(data.item_list[0]?.column || "");
    setCalc(data.item_list[0]?.calc || "");
  }, [data.item_list]);

  const handleColumnChange = (value: string | null) => {
    if (value !== null) {
      setColumn(value);
      if (onUpdate) {
        onUpdate({
          ...data,
          item_list: [{ column: value, calc }],
        });
      }
    }
  };

  const handleCalcChange = (value: string) => {
    setCalc(value);
    if (onUpdate) {
      onUpdate({
        ...data,
        item_list: [{ column, calc: value }],
      });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <Select
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="Select column"
        data={availableColumns.length > 0 ? availableColumns : []}
        value={column}
        onChange={handleColumnChange}
      />
      <Divider orientation="horizontal" />
      <Input
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="Enter formula"
        value={calc}
        onChange={(e) => handleCalcChange(e.target.value)}
      />
    </TransformerBase>
  );
}
